"use client"

import { BriefcaseBusiness } from "lucide-react"
import { component, Icon } from "../icon"

/**
 * `BriefcaseBusinessIcon` is [Lucide](https://lucide.dev) SVG icon component.
 *
 * @see https://yamada-ui.com/docs/components/icon
 */
export const BriefcaseBusinessIcon = component(Icon)({ as: BriefcaseBusiness })
